module.exports = __webpack_public_path__ + "img/489.605719b5.jpg";